module.exports = __webpack_public_path__ + "img/money-inactive-3.860b0cc7.png";